// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__7JM6l","header":"ClearentDisclaimer_header__2SZqX","inner":"ClearentDisclaimer_inner__LO0-N"};